import React from 'react'
import styled from 'styled-components'
import { ChartHistoricalSeriesCP } from 'modules/reports/components/charts/chart-historical-series/ChartHistoricalSeriesCP'
import { TableGenericChartCP } from 'modules/reports/components/tables/table-generic-chart/TableGenericChartCP'
import { CollapseCP } from 'submodules/nerit-framework-ui/common/components/collapse/CollapseCP'
import { CardCP } from 'submodules/nerit-framework-ui/common/components/card/CardCP'
import { HistoricChartRequestDTO } from 'submodules/nerit-aquatec-sdk/services/charts/dtos/requests/HistoricChartRequestDTO'
import { GenericChartResponseDTO } from 'submodules/nerit-aquatec-sdk/services/charts/dtos/responses/GenericChartResponseDTO'
import { ChartsRequests } from 'submodules/nerit-aquatec-sdk/services/charts/ChartsRequests'
import { TitleCP } from 'submodules/nerit-framework-ui/common/components/title/TitleCP'
import Highcharts from 'highcharts'

interface ICPProps {
    data: GenericChartResponseDTO
    locationName: string
    regulationName?: string
    requestDTO: HistoricChartRequestDTO
    showTopSpacing?: boolean
    onChartCreated?: (chart: Highcharts.Chart) => void
}

/**
 */
export function HistoricalChartLocationResultCP(props: ICPProps): JSX.Element {

    const exportFileName = `serie_historica_${props.locationName.replace(/\s+/g, '_')}`

    return (
        <WrapperSCP>
            <TitleCP
                marginLeft={20}
                marginTop={props.showTopSpacing ? 30 : 20}
                marginBottom={10}
                textSize={'normal'}
                underLine={true}
            >
                {props.locationName}
            </TitleCP>
            <ChartHistoricalSeriesCP
                data={props.data}
                filters={{
                    locationName: props.locationName,
                    regulationName: props.regulationName,
                }}
                onChartCreated={props.onChartCreated}
            />
            <CardCP margin={'20px'} innerSpacing={'none'} bordered={true}>
                <CollapseCP
                    bordered={false}
                    defaultPanelKeys={[]}
                    panels={[
                        {
                            key: 'data-table',
                            title: `Dados — ${props.locationName}`,
                            content: (
                                <TableGenericChartCP
                                    data={props.data}
                                    export={{
                                        exportRequestConfig: () => ChartsRequests.getHistoricChartExport(props.requestDTO),
                                        fileName: exportFileName,
                                    }}
                                />
                            ),
                        },
                    ]}
                />
            </CardCP>
        </WrapperSCP>
    )
}

const WrapperSCP = styled.div`
    margin-bottom: 2rem;
`
